module.exports = __webpack_public_path__ + "static/media/picto_cocarde_certification_continuelle.a3bd5ba0.svg";